import createPersistedState from 'vuex-persistedstate'

export default ({store}) => {
	window.onNuxtReady(() => {
		createPersistedState({
			key: 'favoriteList.vuex.tb.co.th',
			paths: [
				'property.favoriteList'
			],
			subscriber: store => handler => {
				// Load property in favorite list if not exist
				store.dispatch('property/getPropertyList', store.getters['property/favoriteList'])

				return store.subscribe(handler)
			}
		})(store)

		createPersistedState({
			key: 'nearbyRoute.vuex.tb.co.th',
			paths: [
				'map.direction'
			],
			subscriber: store => handler => {
				// Change lan/lng to function
				store.dispatch('map/prepareRouteData')
				// console.log(store.getters['map/getDirectionList'])

				return store.subscribe(handler)
			}
		})(store)
	})
}